import { useEffect, useRef, useState } from "react";
import { LIST_BLOCKS } from "../../utils/candidateFunnel";
import { LIST_BLOCK_LABELS } from "./CandidateListView";

/**
 * «Вид карточки» for the hh-like list (доработка №4/№14, 03.11). [Claude]
 * Each user picks which blocks the card shows, in which order, and the density.
 */
export default function CandidateViewSettings({ blocks, density, onChange }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);
    const keys = blocks || [];
    const toggle = (key) => onChange({ list_blocks: keys.includes(key) ? keys.filter((k) => k !== key) : [...keys, key] });
    const move = (key, delta) => {
        const i = keys.indexOf(key);
        const j = i + delta;
        if (i < 0 || j < 0 || j >= keys.length) return;
        const next = [...keys];
        [next[i], next[j]] = [next[j], next[i]];
        onChange({ list_blocks: next });
    };
    return <div className="relative" ref={ref}>
        <button type="button" onClick={() => setOpen((v) => !v)} data-testid="candidate-card-settings"
            className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 hover:bg-slate-50">
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h10M4 18h7" /></svg>
            Вид карточки
        </button>
        {open ? <div className="absolute right-0 z-40 mt-1 w-72 rounded-xl border border-slate-200 bg-white p-3 shadow-xl">
            <div className="mb-3 inline-flex w-full rounded-lg border border-slate-200 p-0.5" role="group" aria-label="Плотность">
                {[["detailed", "Подробно"], ["compact", "Компактно"]].map(([key, label]) => <button key={key} type="button"
                    aria-pressed={density === key} onClick={() => onChange({ density: key })}
                    className={`flex-1 rounded-md px-2 py-1 text-sm ${density === key ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}>{label}</button>)}
            </div>
            <p className="mb-2 text-xs text-slate-500">Что показывать в карточке и в каком порядке — только для вас.</p>
            <ul className="space-y-1">
                {keys.map((key, i) => <li key={key} className="flex items-center gap-2 rounded-lg bg-slate-50 px-2 py-1 text-sm">
                    <input type="checkbox" checked onChange={() => toggle(key)} className="h-4 w-4 accent-amber-500" aria-label={`Скрыть «${LIST_BLOCK_LABELS[key]}»`} />
                    <span className="flex-1 truncate">{LIST_BLOCK_LABELS[key] || key}</span>
                    <button type="button" disabled={i === 0} onClick={() => move(key, -1)} className="px-1 text-slate-400 hover:text-slate-800 disabled:opacity-30" aria-label="Выше">↑</button>
                    <button type="button" disabled={i === keys.length - 1} onClick={() => move(key, 1)} className="px-1 text-slate-400 hover:text-slate-800 disabled:opacity-30" aria-label="Ниже">↓</button>
                </li>)}
                {LIST_BLOCKS.filter((key) => !keys.includes(key)).map((key) => <li key={key} className="flex items-center gap-2 px-2 py-1 text-sm text-slate-500">
                    <input type="checkbox" checked={false} onChange={() => toggle(key)} className="h-4 w-4 accent-amber-500" aria-label={`Показать «${LIST_BLOCK_LABELS[key]}»`} />
                    <span className="flex-1 truncate">{LIST_BLOCK_LABELS[key] || key}</span>
                </li>)}
            </ul>
        </div> : null}
    </div>;
}
